<template>
  <div class="content">
    <div class="loader" v-if="loading">
      <loader/>
    </div>

    <div class="container">
      <div class="page privacy" v-if="!loading">
        <div class="header">
          <ul class="menu-gdpr" :class="{noco: !connected}">
            <li :class="{RGPD: !connected, RGPDco: connected, select: RGPDMenu === 0}">
              <a href="#" @click="clearResponse(0)">{{$t(items[0].title)}}</a>
            </li>
            <li :class="{RGPD: !connected, RGPDco: connected, select: RGPDMenu === 1}">
              <a href="#" @click="clearResponse(1)">{{$t(items[1].title)}}</a>
            </li>
            <li :class="{RGPD: !connected, RGPDco: connected, select: RGPDMenu === 2}">
              <a href="#" @click="clearResponse(2)">{{$t(items[2].title)}}</a>
            </li>
            <li :class="{RGPD: !connected, RGPDco: connected, select: RGPDMenu === 3}">
              <a href="#" @click="clearResponse(3)">{{$t(items[3].title)}}</a>
            </li>
            <li class="RGPDco" :class="{select: RGPDMenu === 4}" v-if="connected === true">
              <a href="#" @click="clearResponse(4)">{{$t('privacy.title.personnalData.title')}}</a>
            </li>
          </ul>
        </div>

        <div v-if="RGPDMenu === 0">
          <p :inner-html.prop="items[0].item.content"></p>
        </div>

        <div v-if="RGPDMenu === 1">
          <p :inner-html.prop="items[1].item.content"></p>
        </div>

        <div v-if="RGPDMenu === 2">
          <p :inner-html.prop="items[2].item.content"></p>
        </div>

        <div v-if="RGPDMenu === 3">
          <p :inner-html.prop="items[3].item.content"></p>
        </div>

        <div v-if="RGPDMenu === 4">
          <p></p>
          <a href="#" class="colored-btn red-btn" @click="exportRequest" :disabled="this.exportsResponse.done === false">{{$t('privacy.title.personnalData.button')}}</a>
          <p class="requestError">{{ReqResponse}}</p>
          <a href="#" class="colored-btn red-btn" @click="openModal">{{$t('privacy.title.forgetData.button')}}</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../components/loader.component';
  import {setBodyHome} from '../../helpers/body-class.helper';
  import {mapState} from 'vuex';
  import {MetaHelper} from "../../helpers/meta.helper";

  export default {
    name: 'privacy',
    components: {Loader},
    async created() {
      await this.$store.dispatch('privacyPage/fetch', {lang: this.$store.state.lang.currentLang})
    },
    metaInfo() {
      return MetaHelper.gdpr(this.$store.state.lang.currentLang);
    },
    data() {
      return {
        RGPDMenu: 0,
        ReqResponse: "",
      }
    },
    computed: mapState({
      loading: state => state.privacyPage.loading,
      items: state => state.privacyPage.items,
      exports: state => state.privacyPage.exports,
      forget: state => state.privacyPage.forget,
      exportsResponse: state => state.privacyPage.exportsResponse,
      forgetsResponse: state => state.privacyPage.forgetsResponse,
      connected: state => state.client.auth
    }),
    methods: {
      openModal() {
        window.dispatchEvent(new Event('app:validation-modal.open'));
      },

      async exportRequest() {
        await this.$store.dispatch('privacyPage/exportRequest');
        if (this.exportsResponse) {
          this.ReqResponse = this.$t('privacy.title.personnalData.okResponse');
        }
        if (this.exportsResponse.done === false) {
          this.ReqResponse = this.$t('privacy.title.personnalData.alreadyResponse');
        }
      },

      clearResponse(menu) {
        this.RGPDMenu = menu;
        this.ReqResponse = "";
      },
    },

    async mounted() {
      setBodyHome();
      await this.$store.dispatch('menu/setIndexActive', 0);
    }
  };
</script>

<style scoped>
  .loader {
    height: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/privacy.vue